import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const Forbidden = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();

  const goToHomePage = () => {
    if (!user) {
      navigate('/login');
    } else if (user.role === 'admin') {
      navigate('/admin');
    } else if (user.role === 'tutor') {
      navigate('/homepage');
    } else {
      // Default fallback
      navigate('/');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      flexDirection: 'column',
      padding: '20px'
    }}>
      <Result
        status="403"
        title="403"
        subTitle={t('forbidden.message', 'Non hai i permessi necessari per accedere a questa pagina')}
        extra={
          <Button type="primary" onClick={goToHomePage}>
            {t('forbidden.backToHome', 'Torna alla Home')}
          </Button>
        }
      />
    </div>
  );
};

export default Forbidden;
